import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Play, Clock, Calendar, Podcast as PodcastIcon } from 'lucide-react';
import { podcasts } from '../data/mock';

const Podcasts = () => {
  return (
    <section id="podcasts" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 font-semibold text-lg mb-2">Audio Insights</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            Tax & Finance Podcast
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Listen to expert discussions on taxation, compliance, and regulatory developments
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {podcasts.map((podcast) => (
            <Card
              key={podcast.id}
              className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-none overflow-hidden"
            >
              <div className="relative overflow-hidden">
                <img
                  src={podcast.image}
                  alt={podcast.title}
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center hover:bg-amber-700 transition-colors shadow-xl transform hover:scale-110 transition-transform">
                    <Play className="w-8 h-8 text-white ml-1" fill="white" />
                  </button>
                </div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-amber-600 text-white hover:bg-amber-700">
                    <PodcastIcon className="w-3 h-3 mr-1" />
                    {podcast.category}
                  </Badge>
                </div>
              </div>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-slate-800 mb-3 group-hover:text-amber-600 transition-colors line-clamp-2">
                  {podcast.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4 line-clamp-2">
                  {podcast.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center text-sm text-gray-500">
                    <Clock className="w-4 h-4 mr-1" />
                    {podcast.duration}
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <Calendar className="w-4 h-4 mr-1" />
                    {new Date(podcast.date).toLocaleDateString('en-US', { 
                      month: 'short', 
                      day: 'numeric'
                    })}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="flex items-center justify-center mb-4">
              <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center">
                <PodcastIcon className="w-8 h-8 text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">
              Subscribe to Stay Updated
            </h3>
            <p className="text-gray-300 text-lg mb-6">
              Get notified when new podcast episodes are released. Expert insights delivered to your inbox.
            </p>
            <button className="bg-amber-600 hover:bg-amber-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors">
              Subscribe Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Podcasts;